<template>
  <div class="my_vote_list">
    <div v-if="noData =='false'">
      <!-- 返回 -->
      <topPart :rightPart="true"></topPart>
      <!-- 返回页 -->
      <!-- 标题 -->
      <div class="list-block">
        <div class="list_block_title">
          <!--类型  -->
          <div :class="'titleStyle ' + getTitileClass(type)">{{getTitleType(type)}}</div>
          <!-- 类型结束 -->
          <!-- 标题 -->
          <div class="nameStyle">{{title}}</div>
          <!-- 标题结束 -->
        </div>

        <div class="list_block_ctn">
          <!-- 内容 -->
          <div class="conterStyle5" v-html="content"></div>
          <!-- 内容结束 -->
          <!-- 附件 -->
          <div class="enclosureBox">
            <div class="enclosureTitle">
              <img class="qbz-icon" src="../../../assets/images/qbz_icon.png" />附件：
            </div>
            <div class="enclosureConter">
              <div v-for="(item,index) in fileList" :key="index" @click="fileOpenFn(item)">
                <div class="van-ellipsis">
                  <a>{{item.fileName}}</a>
                </div>
              </div>
            </div>
          </div>
          <!-- 附件结束 -->
        </div>

        <!-- 时间 -->
        <div class="deal-time">
          <p>截止日期：{{time}}</p>
        </div>
        <!-- 时间结束 -->
      </div>
      <!-- 标题结束 -->

      <!-- 打开文件弹框 -->
      <van-popup
        :lock-scroll="true"
        v-model="openFileShow"
        round
        position="bottom"
        :style="{ height: '160px' }"
      >
        <div class="open_file">
          <div @click="openFileFn">打开文档</div>
          <div @click="copyOpen">复制下载链接</div>
          <div class="open_cancel" @click="cancelOpen">取消</div>
        </div>
      </van-popup>
      <!-- 打开文件弹框 结束-->
    </div>
    <page-none v-if="noData =='true'" />
  </div>
</template>

<script>
import topPart from "../../../components/topPart";
import { toast } from "@/common/api/api.js";
import moment from "moment";
import pageNone from "../../../components/pageNone";
export default {
  props: ["id"],
  components: {
    topPart,
    pageNone
  },
  data() {
    return {
      type: "",
      time: "",
      fileList: [],
      typeConfig: {
        vote: {
          title: "表决",
          style: "vote_color"
        },
        suggest: {
          title: "征求意见",
          style: "suggest_color"
        }
      }, //类型配置
      title: "",
      content: "",
      openFileShow: false,
      currentFile: {},
      noData:"",
      pageNone: ""
    };
  },
  created() {
    //获取详情数据
    this.getDetails();
  },
  methods: {
    // 打开弹框
    fileOpenFn(item) {
      this.currentFile = item;
      this.openFileShow = true;
    },
    // 关闭弹框
    cancelOpen() {
      this.openFileShow = false;
    },
    // 复制
    copyOpen() {
      if (!this.currentFile.filePath) return;
      window.scrollTo(0, 0);
      let that = this;
      let aux = document.createElement("input");
      aux.setAttribute("value", this.currentFile.filePath);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      aux.className = "aux";
      aux.style.display = "none";
      document.body.removeChild(aux);
      setTimeout(() => {
        toast(that, "复制成功", "success");
      }, 800);
      this.cancelOpen();
    },
    // 打开文件
    openFileFn() {
      if (!this.currentFile.filePath) return;
      window.location.href = this.currentFile.filePath;
      this.cancelOpen();
    },
    getTitleType(type) {
      if (!this.typeConfig[type]) return;
      return this.typeConfig[type].title;
    },
    //获取详情参数
    getgetDetailsData() {
      var obj = {
        id: this.id
      };
      return obj;
    },
    //类型 suggest
    suggestfun(data) {
      this.title = data.vote.title; //赋值title
      this.content = data.vote.content; //赋值内容content
      this.time = moment(data.vote.endTime).format("YYYY-MM-DD HH:mm:ss"); //结束时间
    },
    //类型 vote
    votefun(data) {
      this.title = data.vote.title; //赋值title
      this.content = data.vote.content; //赋值内容content
      this.time = moment(data.vote.endTime).format("YYYY-MM-DD HH:mm:ss"); //结束时间
    },
    //处理返回数据
    getDetailsFun(data, message) {
      this.type = data.vote.type;
      //赋值图片
      this.fileList = data.fileList;
      //策略转换数据
      this[this.type + "fun"](data);
    },
    //获取详情数据
    getDetails() {
      var obj = this.getgetDetailsData();
      this.sendQuestion("wechatRepreDetail", obj, "getDetailsFun");
    },
    //后端发送请求函数
    sendQuestion(url, obj, fun) {
      this.centralControl.axios.centralControl(
        url,
        res => {
          const { message, code, data } = res;
          //请求返回 关闭加载页
          this.loading = false;
          if (code == 200) {
            this.noData = "false";
            this[fun](data, message);
          } else {
            this.noData = "true";
            console.log(res, "接口错误-");
          }
        },
        obj
      );
    },
    getTitileClass(type) {
      if (!this.typeConfig[type]) return;
      return this.typeConfig[type].style;
    }
  }
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/theme.styl';

.open_file {
  height: 100%;
  background: #F3F5F9;

  #copyBtn {
    cursor: pointer;
  }

  div {
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: #FFF;
  }

  >div:nth-child(1) {
    border-bottom: 1px solid #EFEFF3;
  }

  .open_cancel {
    margin-top: 9px;
  }
}

.deal-time {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  background: #ffdddd;
  text-align: center;
  padding: 12px;

  p {
    color: rgba(255, 75, 75, 1);
  }
}

.enclosureConter {
  flex: 1;
  min-width: 0;

  a {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(86, 137, 240, 1);
  }
}

.enclosureBox {
  display: flex;
  align-items: baseline;
}

.enclosureTitle {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);

  img {
    width: 18px;
  }
}

.qbz-icon {
  width: 14px;
  height: 15px;
  margin-right: 5px;
}

.titleStyle {
  padding: 4px 7px;
  border-radius: 20px;
  font-size: 11px;
  background: linear-gradient(103deg, rgba(79, 172, 254, 1), rgba(0, 242, 254, 1));
  color: #fff;
  text-align: center;
  display: inline-block;
}

.nameStyle {
  width: 70%;
  margin-left: 1.8%;
  display: inline-block;
  min-width: 0;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.list-block {
  background: #FFF;
  margin-top: 50px;
  height: auto !important;

  .list_block_title {
    padding: 16px;
    border-bottom: 1px solid #EFEFF4;
    display: flex;
  }

  .list_block_ctn {
    padding: 0 16px 16px;
  }
}

.conterStyle5 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  margin-top: 8px;
  color: $text-black;

  >>> img {
    width: 100%;
  }

  >>>p {
    line-height: 20px;
  }

  >>> ol, span, ol, li, ul, h1, h2, strong, em {
    display: inline-block;
  }

  >>>br {
    display: none;
  }
}

.suggest_color {
  background: linear-gradient(103deg, rgba(69, 209, 172, 1), rgba(39, 189, 186, 1));
}

.vote_color {
  background: linear-gradient(103deg, rgba(255, 19, 86, 1), rgba(255, 59, 142, 1), rgba(255, 19, 86, 1));
}
</style>